import { getRefreshedUser } from "core/javascriptChannels";
import { appInsightsLogger } from "core/monitoring/AppInsights";
import { useEffect, useState } from "react";
import { UserAuthState } from "shared/core/state/userAuthState";

interface UseAuthRefreshResult {
  isLoading: boolean;
  error: any;
}

export const useAuthRefresh = (triggerRefresh: boolean, callback?: () => void): UseAuthRefreshResult => {
  const isMobile = !!window.flutter_inappwebview;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>();

  useEffect(() => {
    const fetchRefreshedUser = async () => {
      setIsLoading(true);
      try {
        const userResponse = await getRefreshedUser();
        UserAuthState.set(JSON.parse(userResponse));
        callback && callback();
      } catch (err) {
        appInsightsLogger.error("getRefreshedUserError", err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };
    if (triggerRefresh && isMobile) {
      fetchRefreshedUser();
    }
  }, [callback, isMobile, triggerRefresh]);

  return {
    isLoading,
    error,
  };
};
